const allowedParameter = (value) => ['string', 'number', 'boolean'].includes(typeof value);

export function trackEvent(name, parameters = {}) {
  if (typeof window === 'undefined' || typeof window.gtag !== 'function') return;
  const safeParameters = Object.fromEntries(
    Object.entries(parameters).filter(([, value]) => value !== undefined && value !== null && allowedParameter(value)),
  );
  window.gtag('event', name, safeParameters);
}

export function initializeConversionTracking() {
  if (typeof document === 'undefined' || document.documentElement.dataset.conversionTracking === 'ready') return;
  document.documentElement.dataset.conversionTracking = 'ready';
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href]');
    if (!link) return;
    const href = link.getAttribute('href') || '';
    if (href.startsWith('tel:')) trackEvent('phone_call_click', { link_url: href, page_path: window.location.pathname });
    else if (href === '/request-delivery') trackEvent('request_delivery_click', { page_path: window.location.pathname });
    else if (href.startsWith('mailto:')) trackEvent('email_click', { page_path: window.location.pathname });
  });
}
